<template lang="html">
  <div id="transfer">
    <div class="columns">
      <div class="column">
        <form @submit.prevent="$router.push({ name: 'checkout', query: $route.query })">
          <basic-info></basic-info>
          <hr>
          <fees :create="false"></fees>
          <button type="submit">CONTRATAR</button>
        </form>
      </div>
      <div class="column">
        <div class="content">
          <h3>Serviços</h3>
          <b-table :striped="true" :narrowed="true" :data="serv" :mobile-cards="false" :columns="columnsServ"></b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BasicInfo from '../../components/home/BasicInfo'
import Fees from '../../components/home/Fees'
export default {
  name: 'create',
  data () {
    return {
      data: [],
      columnsValues: [
        {
          field: 'description',
          label: 'Honorário'
        },
        {
          field: 'value',
          label: 'Valor'
        }
      ],
      columnsServ: [
        {
          field: 'serv',
          label: 'Serviços Inclusos'
        },
        {
          field: 'servE',
          label: 'Serviços Extras'
        }
      ],
      form: {
        cityCode: undefined,
        activityCode: undefined,
        partnersQuantity: undefined,
        employeesQuantity: undefined,
        revenue: undefined
      }
    }
  },
  beforeMount () {
  },
  computed: {
    ...mapGetters([
      'serv',
      'calcValues'
    ])
  },
  mounted () {},
  methods: {
    activityCodeParser (index) {
      let keys = [
        'mensalidade_industria',
        'mensalidade_comercio',
        'mensalidade_servico'
      ]
      return keys[index]
    }
  },
  components: {
    BasicInfo,
    Fees
  }
}
</script>
<style lang="scss" type="text/css" media="screen"></style>
